import { useQuery } from "@tanstack/react-query";
import { FIVE_MINUTES_IN_MS } from "../configuration/globalConstants";
import { getAppUsers } from "../services/userServices";

export function useUserList() {
  const users = useQuery({
    queryKey: ["usersList"],
    queryFn: () => getAppUsers(),
    staleTime: FIVE_MINUTES_IN_MS,
  });

  return {
    users: users.data || null,
    isLoadingUsers: users.isLoading,
    reloadUsers: users.refetch,
  };
}
